import { UpdateProfileData } from './UpdateProfileData';

export interface UserProfileUpdateConstructor extends CustomUserInfo {}
export class UserProfileUpdateConstructor implements CustomUserInfo {
  constructor({
    email,
    country,
    firstName,
    lastName,
    ibo,
    sponsorIbo,
  }: UpdateProfileData) {
    this.email = email;
    this.displayName = `${firstName} ${lastName}`;

    this.normalisedEmail = email.toUpperCase();
    this.normalisedFirstName = firstName.toUpperCase();
    this.normalisedLastName = lastName.toUpperCase();
    this.ibo = ibo;
    this.sponsorIbo = sponsorIbo;
    this.country = country;
  }
}
